import { Typography, TypographyProps } from '@mui/material';

interface IMoneyTextProps extends Omit<TypographyProps, 'children'> {
  value: number;
}

export const MoneyText: React.FC<IMoneyTextProps> = ({ value, sx, ...rest }) => {
  return (
    <Typography
      fontWeight={700}
      color="success.main"
      sx={{ letterSpacing: '0.2px', ...sx }}
      {...rest}
    >
      {value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
    </Typography>
  );
};
